/** Explicit receipt rows only. The API must never auto-receive every PO line. */
export function buildGoodsReceiptPayload(formData, removedItemIds, requestKey) {
  return {
    receipt_date: formData.receipt_date,
    comment: formData.comment || "",
    purchase_id: formData.purchase_id || null,
    request_key: requestKey,
    items_attributes: [
      ...(formData.items || []).filter((item) => item.purchase_item_id || Number(item.quantity_received) > 0).map((item) => ({
        ...(item.id ? { id: item.id } : {}),
        purchase_item_id: item.purchase_item_id || null,
        product_id: item.product_id,
        quantity_received: item.quantity_received === "" ? 0 : item.quantity_received,
        quantity_expected: item.purchase_item_id ? (item.quantity_expected || 0) : (item.quantity_received || 0),
        storage_id: item.storage_id || null,
        unit_id: item.unit_id || null,
        comment: item.comment || "",
      })),
      ...removedItemIds.map((itemId) => ({ id: itemId, _destroy: true })),
    ],
  };
}
